export const ADMIN = "admin";
export const RESTO = "resto";